import { PaymentResponseRedirect } from "@swo/storefront";

export function clientSideRedirect(data: PaymentResponseRedirect) {
  switch (data.method) {
    case "GET": {
      const s = new URLSearchParams(data.parameters);
      const paramsStr = s.toString();

      let href = data.url;
      if (paramsStr.length > 0) {
        href = `${href}?${paramsStr}`;
      }

      return {
        action: () => {
          window.location.href = href;
        },
        tag: "GET" as const,
        value: href,
      };
    }

    case "POST": {
      let form = document.createElement("form");
      form.setAttribute("method", data.method);
      form.setAttribute("action", data.url);

      const inputs = Object.entries(data.parameters).flatMap(([name, value]) => {
        if (typeof value !== "string") {
          console.warn(`Invalid parameter type '${name}' with value: `, value);

          return [];
        }

        const i = document.createElement("input");
        i.setAttribute("type", "hidden");
        i.setAttribute("name", name);
        i.setAttribute("value", value);

        return [i];
      });

      inputs.forEach(i => {
        form.appendChild(i);
      });

      document.body.appendChild(form);

      return {
        action: () => {
          form.submit();
        },
        tag: "POST" as const,
        value: () => form.submit(),
      };
    }
  }
}
